"use client";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import React from "react";

const PageTitle = () => {
  const translate = useTranslations('page_names');
  const path = usePathname();

  const formattedTitle = path.split("/")[2] ?? "";
  const capitalize = (str: string) => [str.charAt(0).toUpperCase(), str.substring(1)].join("");
  return (
    <div className="py-2 px-8 bg-chrome-600 font-bold text-chrome-100 uppercase">
      {translate(capitalize(formattedTitle))}
    </div>
  );
};

export default PageTitle;
